import { defineAsyncComponent } from 'vue';

import { constants } from '@/config';

const App = () => import('@/app/snapchat/App.vue');
const Overview = () => import('@/app/snapchat/pages/Overview.vue');
const AnalyticsYourPostsPage = defineAsyncComponent(
  () => import('@/components/core/analytics/AnalyticsYourPostsPage.vue'),
);
const BoardsIndex = () => import('@/app/boards/pages/BoardsIndex.vue');

const PAGE_LEVEL_TOP = 'Snapchat';
const PAGE_LEVEL_BOARDS = 'Boards';

export default {
  path: 'snapchat',
  component: App,
  meta: {
    requiresAuth: true,
  },
  children: [
    {
      name: 'snapchat',
      path: '',
      redirect: { name: 'snapchat.overview' },
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - Overview`,
      },
    },
    {
      name: 'snapchat.overview',
      path: 'overview',
      component: Overview,
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - Overview`,
      },
    },
    {
      name: 'snapchat.yourPosts',
      path: 'your-posts',
      component: AnalyticsYourPostsPage,
      props: {
        channel: constants.SNAPCHAT,
      },
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - Your Posts`,
      },
    },
    {
      name: 'snapchat.yourPosts.report',
      path: 'your-posts/report',
      component: AnalyticsYourPostsPage,
      props: {
        channel: constants.SNAPCHAT,
      },
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - Your Posts Report`,
        report: true,
      },
    },
    {
      path: 'boards',
      children: [
        {
          name: 'snapchat.galleries',
          path: '',
          component: BoardsIndex,
          props: {
            galleryType: constants.SNAPCHAT,
          },
          meta: {
            analytics: `${PAGE_LEVEL_TOP} - ${PAGE_LEVEL_BOARDS}`,
          },
        },
      ],
    },
  ],
};
